import utils from '../utils';

export default function extendDayMarkModel(model) {
  const result = { ...model };

  if (!result.dtstart) {
    return model;
  }

  if (typeof result.dtstart === 'string') {
    result.dtstart = utils.getRealDate(result.dtstart);
    result.dtend = utils.getRealDate(result.dtend);
  }

  return result;
}
